var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: {
      title: _vm.modalTitle,
      customAlignment: "addDirection",
      withBgClickEvent: true,
    },
    on: { close: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "grow w-full" },
              [
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, errors, invalid }) {
                        return [
                          _vm.showStatusDropdown
                            ? _c("ValidationProvider", {
                                attrs: {
                                  rules: "required_field",
                                  name: "Status",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              attrs: { errors: errors },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "required-icon",
                                                              },
                                                              [_vm._v("*")]
                                                            ),
                                                            _vm._v(" Status "),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "CustomRequestStatusMultiselect",
                                                {
                                                  attrs: {
                                                    value: _vm.request.status,
                                                    multiple: false,
                                                  },
                                                  on: {
                                                    input: (val) =>
                                                      (_vm.request.status =
                                                        val),
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "mt-3.5" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  rules: "required_field",
                                  name: "Job title",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("FormGroup", {
                                            attrs: {
                                              isIcon: false,
                                              type: "search",
                                              errors: errors,
                                              inputClass: "w-full",
                                              name: "job_title",
                                              placeholder: "Enter job title",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "title",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(" Job Title "),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.request.jobTitle,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.request,
                                                  "jobTitle",
                                                  $$v
                                                )
                                              },
                                              expression: "request.jobTitle",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mt-3.5" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  rules: "required_field",
                                  name: "Number of contractors",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("FormGroup", {
                                            attrs: {
                                              errors: errors,
                                              isIcon: false,
                                              title: "Number of contractors",
                                              inputClass: "w-full",
                                              name: "number_of_contractors",
                                              placeholder:
                                                "Enter number of contractors",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "title",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(
                                                            " Number of contractors "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.request
                                                  .number_of_contractors,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.request,
                                                  "number_of_contractors",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "request.number_of_contractors",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mt-3.5" },
                            [
                              _c(
                                "FormGroup",
                                { attrs: { title: "Skills:" } },
                                [
                                  _c("SkillsMultiselect", {
                                    attrs: {
                                      getParentStyle: "customWidthInput",
                                      limit: _vm.skillsMultiselectLimit,
                                      max: 10,
                                    },
                                    model: {
                                      value: _vm.request.skills,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.request, "skills", $$v)
                                      },
                                      expression: "request.skills",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "mt-3.5" },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "w-full",
                                    attrs: {
                                      rules:
                                        "noSmaller:@max_budget|required_field",
                                      name: "Min budget",
                                      delay: "1000",
                                      vid: "min_budget",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(
                                                "FormGroup",
                                                {
                                                  attrs: {
                                                    id: "title",
                                                    errors: errors,
                                                    name: "Mininmum Budget",
                                                    placeholder:
                                                      " Minimum Budget",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "title",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "required-icon",
                                                                  },
                                                                  [_vm._v("* ")]
                                                                ),
                                                                _vm._v(
                                                                  "Minimum Budget"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("FormInputGroup", {
                                                    attrs: {
                                                      invalid: failed,
                                                      height: true,
                                                      placeholder: "Min",
                                                      inputClasses: "pl-8",
                                                      type: "number",
                                                      prefix: "$",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.request.min_budget,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.request,
                                                          "min_budget",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "request.min_budget",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "mt-3.5" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "w-full",
                                        attrs: {
                                          name: "Max budget",
                                          vid: "max_budget",
                                          rules:
                                            "noBigger:@min_budget|required_field",
                                          delay: "1000",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({
                                                errors,
                                                failed,
                                              }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        id: "title",
                                                        name: "Maximum Budget",
                                                        errors: errors,
                                                        placeholder:
                                                          " Maximum Budget",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "title",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required-icon",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "* "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "Maximum Budget"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("FormInputGroup", {
                                                        attrs: {
                                                          invalid: failed,
                                                          height: true,
                                                          placeholder: "Max",
                                                          inputClasses: "pl-8",
                                                          type: "number",
                                                          prefix: "$",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.request
                                                              .max_budget,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.request,
                                                              "max_budget",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "request.max_budget",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "div",
                                { staticClass: "row-span-full" },
                                [
                                  _c("p", { staticClass: "mb-2 mt-3.5" }, [
                                    _vm._v("Duration"),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "flex" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mt-2 mr-2 flex flex-row",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "required-icon" },
                                            [_vm._v("* ")]
                                          ),
                                          _vm._v(" From"),
                                        ]
                                      ),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: "required_field",
                                          vid: "from_date",
                                          name: "From date",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({
                                                errors,
                                                failed,
                                              }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        errors: errors,
                                                        name: "From Date",
                                                      },
                                                    },
                                                    [
                                                      _c("FormDatepicker", {
                                                        attrs: {
                                                          heightClass:
                                                            "datePickerHeight",
                                                          customInputClass: true,
                                                          calendarClass:
                                                            "bottom-11",
                                                          invalid: failed,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.request
                                                              .from_date,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.request,
                                                              "from_date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "request.from_date",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mt-2 ml-2 mr-2 flex flex-row",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "required-icon" },
                                            [_vm._v("* ")]
                                          ),
                                          _vm._v("Till"),
                                        ]
                                      ),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules:
                                            "noBeforeDate:@start_date,@ongoing|required_field",
                                          vid: "end_date",
                                          name: "Till date",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({
                                                errors,
                                                failed,
                                              }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        errors: errors,
                                                        name: "Till Date",
                                                      },
                                                    },
                                                    [
                                                      _c("FormDatepicker", {
                                                        attrs: {
                                                          heightClass:
                                                            "datePickerHeight",
                                                          customInputClass: true,
                                                          calendarClass:
                                                            "right-0 bottom-11",
                                                          invalid: failed,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.request.to_date,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.request,
                                                              "to_date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "request.to_date",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("p", { staticClass: "mb-2" }, [
                                    _vm._v("Type"),
                                  ]),
                                  _c("TagMultiselect", {
                                    staticClass: "mb-3.5",
                                    attrs: {
                                      selectedTagId: _vm.request.tag_id,
                                      getcontainerStyle: "customFullWidthInput",
                                    },
                                    on: { input: _vm.setTagId },
                                    model: {
                                      value: _vm.request.tag_id,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.request, "tag_id", $$v)
                                      },
                                      expression: "request.tag_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "FormGroup",
                                { attrs: { title: "Description" } },
                                [
                                  _c("FormTextArea", {
                                    attrs: {
                                      customBorderClass: "borderTen",
                                      name: "description",
                                      placeholder: "Enter description",
                                      rows: 3,
                                    },
                                    model: {
                                      value: _vm.request.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.request,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "request.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex mt-4 ml-auto justify-end" },
                            [
                              _c("UIButton", {
                                staticClass: "mr-4",
                                attrs: {
                                  variant: "outline",
                                  buttonText: "Cancel",
                                  buttonClasses: "customButtonCard",
                                },
                                on: { click: _vm.handleClose },
                              }),
                              _c("UIButton", {
                                attrs: {
                                  disabled: invalid,
                                  variant: "black",
                                  processing: _vm.processing,
                                  buttonClasses: "customButtonCard",
                                  buttonText: "Submit",
                                },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.onSubmit)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }